import { render, staticRenderFns } from "./TaTextLeft.vue?vue&type=template&id=639d4483&scoped=true&"
import script from "./TaTextLeft.vue?vue&type=script&lang=js&"
export * from "./TaTextLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d4483",
  null
  
)

export default component.exports